// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1fP0N","upload":"Small_upload__3wOma","imageWrap":"Small_imageWrap__Sy96n","removeBtn":"Small_removeBtn__1LevX"};